import React from 'react';

const ProfitIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="54"
    height="51"
    viewBox="0 0 54 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M27 36.6316C27 43.4624 32.5965 49 39.5 49C46.4035 49 52 43.4624 52 36.6316C52 29.8007 46.4035 24.2632 39.5 24.2632C32.5965 24.2632 27 29.8007 27 36.6316ZM27 36.6316C27 33.8467 27.9302 31.2768 29.5 29.2093V6.94737M27 36.6316C27 38.6734 27.5 40.5994 28.3853 42.2966C26.2793 44.0571 21.4146 45.2895 15.75 45.2895C8.15608 45.2895 2 43.0745 2 40.3421V6.94737M29.5 6.94737C29.5 9.67973 23.344 11.8947 15.75 11.8947C8.15608 11.8947 2 9.67973 2 6.94737M29.5 6.94737C29.5 4.21501 23.344 2 15.75 2C8.15608 2 2 4.21501 2 6.94737M2 29.2105C2 31.943 8.15608 34.1579 15.75 34.1579C21.2225 34.1579 25.9482 33.0076 28.1615 31.3423M29.5 18.0789C29.5 20.8114 23.344 23.0263 15.75 23.0263C8.15608 23.0263 2 20.8114 2 18.0789"
      stroke="#313485"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ProfitIcon;
